import React, { useState } from "react";
import toast from "react-hot-toast";
import { IconButton } from "../../components";
import { FiltersAppliedWarningMessage, Main, PageSubHeader, ThemedIcon } from "../../components/utilities";
import { useFilterContext } from "../../hooks/FilterContext";
import AssetsTable from "./components/AssetsTable";
import AssetTableFilterModal from "./components/AssetTableFilterModal";
import EditAssetModal from "./components/EditAssetModal";
import { useAssetsManagement } from "./hooks/AssetsManagementContext";

const AssetsManagementHeader = () => {
    const [isFiltersShown, setIsFiltersShown] = useState();
    const { defaultFilters, setFilter, isFiltersApplied } = useFilterContext();

    const {
        createAsset,
        createResult,
    } = useAssetsManagement();

    const onCreate = (e) => {
        e.preventDefault();

        toast.promise(createAsset(), {
            loading: "Creating asset...",
            error: "Unable to create asset.",
            success: "Asset created!"
        });
    };

    const onClearFilters = () => {
        setFilter((_) => defaultFilters);
    };

    return (
        <>
            <PageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <button className="anchor" onClick={onClearFilters}>Click here</button> to clear your filters.
                                </FiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <IconButton icon={['fas', 'filter']} onClick={() => setIsFiltersShown(true)}>
                            Filter Assets
                        </IconButton>
                        <IconButton
                            onClick={onCreate}
                            disabled={createResult.isLoading}
                            variant="success"
                            icon={"fa-plus"}
                        >
                            Create New Asset
                        </IconButton>
                    </div>
                </div>
            </PageSubHeader>
            <AssetTableFilterModal
                show={isFiltersShown}
                onHide={() => setIsFiltersShown(null)}
            />
            <EditAssetModal />
        </>
    )
};

const AssetsManagement = () => {

    return (
        <Main className="d-flex flex-column">
            <AssetsManagementHeader />
            <section className="px-4 my-3 h-100">
                <AssetsTable />
            </section>
        </Main>
    )
};

export default AssetsManagement;